/**
 * Site compliance stage — structure-scoped, nested in the site dashboard.
 *
 * Rendered as a child route of SiteDashboardLayout, inside the shared
 * dashboard shell (which supplies AppNav + TitleBar). Compliance/operational
 * reports view for a specific site — replaces Proof of Performance for
 * Little One devices.
 *
 * Contains:
 * - SiteComplianceView — route child component (default export)
 */
import { Box, Container, Paper } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useUser } from '@sophocles/app';
import LoadingScreen from '@sophocles/components/LoadingScreen';
import { fetchOperationalReports, setFilters } from '@sophocles/features/reports';
import { useSiteDashboardLayoutContext } from '@sophocles/views/sites/SiteDashboardLayout';

import { OperationalReportsTable } from './components';

const SiteComplianceView = () => {
  const dispatch = useDispatch();
  const { isStaff } = useUser();
  const { siteId, loading, isBillboard } = useSiteDashboardLayoutContext();

  useEffect(() => {
    if (siteId) {
      dispatch(setFilters({ site: siteId }));
      dispatch(fetchOperationalReports({ site: siteId, limit: 50 }));
    }
  }, [siteId, dispatch]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%', overflowY: 'auto' }}>
      <Container maxWidth="xl" sx={{ mt: 3, mb: 3 }}>
        <Paper sx={{ p: 3 }}>
          <OperationalReportsTable isStaff={isStaff} hideSiteColumn={true} isBillboard={isBillboard} />
        </Paper>
      </Container>
    </Box>
  );
};

export default SiteComplianceView;
